import { Button, Typography, useTheme } from "@monolith-forensics/monolith-ui";
import { useState } from "react";
import { ChangeUserRoleConfirmModal } from "../Modals";

export const UpdateUserRoleSection: React.FC<{
  user: any;
  relayInfo: any;
  onSubmit?: () => void;
}> = ({ user, relayInfo, onSubmit }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const isAdmin = user.is_admin === 1;

  const handleClose = () => setOpen(false);

  const handleRemove = () => setOpen(true);

  return (
    <div>
      <Typography variant="h3" display="inline">
        Change User Role
      </Typography>
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ color: theme.palette.text.secondary, marginTop: 5 }}>
          Add or remove Relay admin status from this user. Admins can grant
          Relay Access to other users.
        </div>
        <ChangeUserRoleConfirmModal
          defaultInfo={{ ...relayInfo, ...user }}
          show={open}
          onClose={handleClose}
          onCancel={handleClose}
          onSubmit={onSubmit}
        />
        <Button
          variant="contained"
          color={isAdmin ? "error" : "green"}
          size="xs"
          onClick={handleRemove}
        >
          {isAdmin ? "Revoke Admin Role" : "Grant Admin Role"}
        </Button>
      </div>
    </div>
  );
};
